<template>
  <div>Statistics</div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "statistics",
  props: {
    id: Number,
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("sea.pages.statistics.title");
    });
  },
});
</script>
